import { render, staticRenderFns } from "./InventoriesLayout.vue?vue&type=template&id=77d4373c"
import script from "./InventoriesLayout.vue?vue&type=script&lang=js"
export * from "./InventoriesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports